/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalSystemSetupDto } from './MedicalSystemSetupDto';
import {
    instanceOfMedicalSystemSetupDto,
    MedicalSystemSetupDtoFromJSON,
    MedicalSystemSetupDtoFromJSONTyped,
    MedicalSystemSetupDtoToJSON,
} from './MedicalSystemSetupDto';
import type { MvTherapySystemSetupDto } from './MvTherapySystemSetupDto';
import {
    instanceOfMvTherapySystemSetupDto,
    MvTherapySystemSetupDtoFromJSON,
    MvTherapySystemSetupDtoFromJSONTyped,
    MvTherapySystemSetupDtoToJSON,
} from './MvTherapySystemSetupDto';

/**
 * @type MedicalSystemSetupBaseDto
 * 
 * @export
 */
export type MedicalSystemSetupBaseDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } & MedicalSystemSetupDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } & MvTherapySystemSetupDto;


export function MedicalSystemSetupBaseDtoFromJSON(json: any): MedicalSystemSetupBaseDto {
    return MedicalSystemSetupBaseDtoFromJSONTyped(json, false);
}

export function MedicalSystemSetupBaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemSetupBaseDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, MedicalSystemSetupDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, MvTherapySystemSetupDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of MedicalSystemSetupBaseDto exists with '$type=${json['$type']}'`);
    }
}

export function MedicalSystemSetupBaseDtoToJSON(value?: MedicalSystemSetupBaseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return MedicalSystemSetupDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return MvTherapySystemSetupDtoToJSON(value);
        default:
            throw new Error(`No variant of MedicalSystemSetupBaseDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the MedicalSystemSetupBaseDto interface.
 */
export function instanceOfMedicalSystemSetupBaseDto(value: any): value is MedicalSystemSetupBaseDto {
    if (instanceOfMedicalSystemSetupDto(value)) return true;
    if (instanceOfMvTherapySystemSetupDto(value)) return true;
    return false;
}

